(function (){
    'use strict';
    angular.module('Services').service('AdminCurrentUserTableService', AdminCurrentUserTableService);
    AdminCurrentUserTableService.$inject=[
        'TableLiteFactory',
        'AdminPermissionService',
        '$location',
        'toastr'
    ];

    function AdminCurrentUserTableService(
        TableLiteFactory,
        AdminPermissionService,
        $location,
        toastr
    ){
       
        return function(){
           
            
            const tableData = {
                config: {
                    noPagination: false, 
                    noHeaders: false, 
                    noItemsView: false, 
                    noTableFooter: false, 
                    colMinWidth: '135px'
                },
                optionAddOns: {
                    buttons: [{
                        label: 'CREATE NEW USER',
                        onClick: function (){
                            $location.path('/administration/new');
                        },
                        class: 'btn-warning',
                    }]
                },
                headers: [
                    {
                        viewName: 'staff',
                        label: 'Staff Member',
                        //width: '205px',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            class: 'table-input',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                        },
                        headerFn: function () {
                            sort('id');
                        }
                        
                    },{
                        viewName: 'email',
                        label: 'Email',
                        filterName:'email',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            class: 'table-input',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                        },
                        headerFn: function () {
                            sort('id');
                        }
                    },{
                        viewName: 'active',
                        label: 'Status',
                        width: '205px',
                        filterName:'active',
                        filter: {
                            type: 'select2',
                            placeholder: 'Search',
                            class: 'table-input',
                            items:['Active','InActive'],
                            onSubmit: function (header) {
                                const filter = {};
                                filter[header.filterName] = header.filter.model === 'Active';
                                sendRequest(filter);
                            },
                        },
                        
                    },{
                        viewName: 'actions',
                        label: 'Actions'
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AdminPermissionService.AdminCurrentUser.getAdminCurrentUserList,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 10,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            
            function buildTableData(data){
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    //let dateTime = item.createdDate.split(" ")
                        item.staff = item.user.firstName +' '+ item.user.lastName;
                        item.email = item.user.email;
                        item.active={
                            type: 'status',
                            status: item.user.active,
                            label: item.user.active ? 'Active' : 'Inactive'
                        };
                        item.actions= {
                                type: 'button',
                                buttons:[{
                                    text: 'View',
                                    action:  function () {
                                        $location.path('/administration/admin-accounts/'+item.user.id); //: change detailsId to id
                                    },
                                    class: 'btn-info btn-quirk btn-sm'
                                },
                                // { 
                                //     text: 'Delete',
                                //     action:  function () {
                                       
                                //         deleteAdminAccount(item.user.id)
                                //     },
                                //     class: 'btn-danger btn-quirk btn-sm'
                                // },
                                { 
                                        text: item.user.active ? 'Disable' :'Enable',
                                        action:  function () {
                                            let payload = {
                                                id:item.user.id,
                                                status: item.user.active ? false:true 
                                            }
                                            userStatus(payload)
                                        },
                                        class: item.user.active ? 'btn-danger btn-quirk btn-sm' :'btn-primary btn-quirk btn-sm'
                                }
                                ]
                            }
                        tableData.data.push(item);
                });

              
            }
            this.tableData = tableData;

            function deleteAdminAccount(id) {
                AdminPermissionService.AdminCurrentUser.deleteAdminUserAccount(success => {
                    toastr.error('Admin account deleted', 'Success!');
                    tableActions.sendRequest()
                }, error => {
                    toastr.error(error.message, 'Error!');
                }, id);
            }

            function userStatus(payload){
                AdminPermissionService.AdminCurrentUser.disabledAdminAccount(
                    res=>{
                        tableActions.sendRequest()
                    },
                    err=>{
                        console.log(err)
                    },
                    payload
                );
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/administrationTable/AdminCurrentUserTableService.js